/**
 * Auto-generated by yarn cross-type:gen-typescript. Do not edit by hand.
 *
 * @source dashboard/lib/shared/braze/remote_lookup/providers/campaign_remote_lookup_provider.rb
 * @owner @Appboy/messaging-experience
 */

import { z } from "zod";
import { common } from "../../../../common";

/** @see [ruby definition](../../../../../../../../lib/shared/braze/remote_lookup/providers/campaign_remote_lookup_provider.rb) */
export const filtersTypeSchema = z.strictObject({
  territory_ids: z.array(common.objectId).nullable().optional(),
});

/** @see [ruby definition](../../../../../../../../lib/shared/braze/remote_lookup/providers/campaign_remote_lookup_provider.rb) */
export const filtersTypeOutputSchema = z.object({
  territory_ids: z.array(common.objectId),
});
